import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { AppShell } from "./AppShell.js";
import { Home } from "./routes/Home.js";
import { Styleguide } from "./routes/Styleguide.js";
import { Vault } from "./routes/Vault.js";
import "./design/index.css";

const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/vault", element: <Vault /> },
      { path: "/styleguide", element: <Styleguide /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);

function NotFound(): React.ReactElement {
  return (
    <div className="container section">
      <h1>Nicht gefunden</h1>
      <p style={{ marginTop: "var(--space-2)", color: "var(--color-granite)" }}>
        Diese Seite gibt es nicht.
      </p>
    </div>
  );
}

const container = document.getElementById("root");
if (!container) throw new Error("Wurzelelement #root fehlt.");

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
